<template>
  <button
    class="button text-nowrap"
    :class="className"
    :type="buttonType"
    :data-disabled="disabled"
    :data-cancel="isCancel"
    v-on="$listeners"
  >
    {{ label }}
  </button>
</template>
<script>
export default {
  name: "Button",
  props: {
    className: {
      type: String,
      default: ""
    },
    disabled: {
      type: Boolean,
      default: false
    },
    isCancel: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      required: true
    },
    buttonType: {
      type: String,
      default: "button"
    }
  }
};
</script>
<style lang="scss" scoped>
.button {
  border-radius: 3px;
  background-color: $gold;
  color: $white;
  padding: 10px 62px;
  border: none;
  font-size: 14px;

  &[data-disabled="true"] {
    background-color: $light-gray;
    pointer-events: none;
    cursor: not-allowed;
  }

  &[data-cancel="true"] {
    color: $gold;
    background-color: $white;
    padding-left: 32px;
    padding-right: 32px;
    border: solid 1px #e1a236;

    &[data-disabled="true"] {
      color: $light-gray;
      border: solid 1px $light-gray;
    }
  }
}
</style>
